// extracted by mini-css-extract-plugin
export default {"project":"ProjectCard_project__SPnrl","banner":"ProjectCard_banner__KzNEl","title":"ProjectCard_title__yv+6l","description":"ProjectCard_description__IfPVH"};